(() => {
  const cfg = window.themeConfig || {};
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const drawer = $('[data-cart-drawer]');
  const scrim = $('[data-cart-scrim]');
  const esc = s => String(s).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));

  function money(cents) {
    const fmt = cfg.moneyFormat || '€{{amount}}';
    const n = (cents / 100);
    const dot = n.toFixed(2);
    const comma = dot.replace('.', ',');
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => k.includes('comma') ? comma : k.includes('no_decimals') ? Math.round(n) : dot);
  }

  function open(o) {
    if (!drawer) return false;
    drawer.hidden = !o; scrim.hidden = !o;
    if (o) $('[data-cart-close]', drawer)?.focus();
    return true;
  }

  async function render() {
    if (!drawer) return;
    const cart = await fetch(cfg.root + 'cart.js', { headers: { Accept: 'application/json' } }).then(r => r.json());
    $$('[data-cart-count]').forEach(el => el.textContent = cart.item_count);
    const lines = $('[data-cart-lines]', drawer);
    const inCart = new Set(cart.items.map(i => i.product_id));
    lines.innerHTML = cart.items.length ? cart.items.map(i => `
      <div class="line">
        ${i.image ? `<img src="${esc(i.image)}" alt="">` : '<span></span>'}
        <div class="t">${esc(i.product_title)}${i.variant_title && !i.product_has_only_default_variant ? `<br><small class="muted">${esc(i.variant_title)}</small>` : ''}
          <div class="qty"><button type="button" data-qty="${esc(i.key)}" data-to="${i.quantity - 1}" aria-label="Decrease">−</button><span>${i.quantity}</span><button type="button" data-qty="${esc(i.key)}" data-to="${i.quantity + 1}" aria-label="Increase">+</button></div>
        </div>
        <div class="lp">${money(i.final_line_price)}</div>
      </div>`).join('') : `<div class="empty">${esc(drawer.dataset.empty || 'Your cart is empty.')}</div>`;
    const tpl = $('[data-cart-upsells]', drawer);
    if (tpl && cart.items.length) {
      const pick = [...tpl.content.querySelectorAll('.up')].find(u => !inCart.has(+u.dataset.productId));
      if (pick) lines.append(pick.cloneNode(true));
    }
    const ship = $('[data-cart-ship]', drawer);
    const free = cfg.freeShipping || 0;
    if (free > 0) {
      const left = free - cart.total_price;
      const txtLeft = (drawer.dataset.left || 'Add [amount] for free shipping').replace('[amount]', `<b>${money(left)}</b>`);
      const txtDone = drawer.dataset.done || 'Free shipping unlocked';
      ship.innerHTML = (left > 0 ? txtLeft : esc(txtDone)) + `<div class="track"><i style="width:${Math.min(100, cart.total_price / free * 100)}%"></i></div>`;
    } else ship.hidden = true;
    $('[data-cart-total]', drawer).textContent = money(cart.total_price);
  }

  async function add(id, qty = 1) {
    const r = await fetch(cfg.root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: +id, quantity: qty }] }) });
    if (!r.ok) { const e = await r.json().catch(() => ({})); alertLine(e.description || 'Could not add this item.'); return false; }
    await render(); open(true); return true;
  }
  function alertLine(msg) {
    const lines = $('[data-cart-lines]', drawer);
    if (lines) { open(true); lines.insertAdjacentHTML('afterbegin', `<p class="form-msg err">${esc(msg)}</p>`); }
  }

  document.addEventListener('submit', async e => {
    const f = e.target.closest('form[data-ajax-add]');
    if (!f || !drawer) return;
    e.preventDefault();
    const btn = f.querySelector('[type=submit]');
    const id = new FormData(f).get('id');
    const label = btn?.textContent;
    if (await add(id) && btn) { btn.textContent = '✓'; btn.classList.add('done'); setTimeout(() => { btn.textContent = label; btn.classList.remove('done'); }, 1000); }
  });

  document.addEventListener('click', async e => {
    const t = e.target.closest('[data-cart-open],[data-cart-close],[data-qty],[data-upsell-add],[data-filter],[data-thumb]');
    if (!t) return;
    if (t.matches('[data-cart-open]')) { if (open(true)) { e.preventDefault(); render(); } }
    if (t.matches('[data-cart-close]')) open(false);
    if (t.matches('[data-qty]')) {
      await fetch(cfg.root + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: t.dataset.qty, quantity: +t.dataset.to }) });
      render();
    }
    if (t.matches('[data-upsell-add]')) add(t.dataset.upsellAdd);
    if (t.matches('[data-filter]')) {
      const f = t.dataset.filter;
      $$('[data-filter]', t.parentElement).forEach(c => c.setAttribute('aria-pressed', c === t));
      const grid = t.closest('section').querySelector('[data-grid]');
      $$('.card', grid).forEach(c => { c.hidden = f !== 'all' && !(c.dataset.tags || '').split(',').includes(f); });
    }
    if (t.matches('[data-thumb]')) {
      const main = t.closest('.gal').querySelector('.main');
      if (main) { main.removeAttribute('srcset'); main.src = t.dataset.thumb; }
      $$('[data-thumb]', t.parentElement).forEach(b => b.setAttribute('aria-pressed', b === t));
    }
  });

  scrim?.addEventListener('click', () => open(false));
  document.addEventListener('keydown', e => { if (e.key === 'Escape') open(false); });
  $('[data-variant-select]')?.addEventListener('change', e => {
    const o = e.target.selectedOptions[0];
    const p = $('[data-price]'); if (p && o?.dataset.price) p.textContent = o.dataset.price;
  });
})();
